import jsrender from "../../../libraries/jsrender.min";
import { GoogleUaEvent } from "../../dataLayerServices/googleUaEvent";
import { DataLayerService } from "../../dataLayerServices/dataLayerService";
import QliroUpdate from "../../qliroUpdate";
import AddToWatchlist from "../../profile/addToWatchList";
import {showLoginDialog} from "../../header/components/initDialogs";
import {userIsLoggedIn} from "../../profile/profile";
import AddToWatchlistCookie from "../../profile/addToWatchListCookie";
import {DisableControls} from "../../checkout";

window.$ = window.jQuery = $;

jsrender();
$(function () {
  $(document).on("blur keydown", ".basket-table .quantity input.quantity", function (e) {
    var isChange = false;
    if (e.type == "keydown") {
      if (e.keyCode == 13) {
        e.preventDefault();
        isChange = true;
      }
    }
    else {
      isChange = true;
    }
    if (isChange) {
      ChangeQuantityForProduct($(this));
    }
  });
  $(document).on("click", ".basket-table .quantity button", function () {
    ChangeQuantityForProduct($(this));
  });
  if ($(".order-table").length > 0) {
    initCatalog();
  }

  $(document).on('click', function (e) {
    var target = e.target;
    var targetParent = $(target).parent();
  
    if ($(target).attr('data-product')) {
      var buttonDataArr = $(target).attr('data-product').split(" ");
      
      if ($(target).hasClass("btn-add-to-cart")) {
        AddToCartProduct($(target), ...buttonDataArr);
      }
  
      if ($(target).hasClass("btn-watchlist-add") && buttonDataArr[0]) {
        if (userIsLoggedIn()) {
          AddToWatchlist(buttonDataArr[0]);
        } else {
          AddToWatchlistCookie(buttonDataArr[0])
          showLoginDialog();
        }
      }
    }
    if($(target).hasClass('fees-delete-code-button')) {
      var feeData = $(target).attr('data-feeId');
      DeleteDiscountProduct(feeData);
    }
    if (targetParent.hasClass("delete-sprite")) {
      ConfirmDeleting($(target).closest(".delete-sprite").parent());
    }
    if (target.matches('.confirm-open')) {
      ConfirmDeleting($(target));
    }
    if (target.matches('.delete-sprite')) {
      ConfirmDeleting(targetParent);
    }
    if (target.matches('.yes.func-delete-product')) {
      var yesData = $(target).attr('data-yes');

      DeleteCartProduct(yesData, $(target));
    }
    if (target.matches('.yes.func-clear-cart')) {
      ClearCart();
    }
    if (target.matches('.confirm-close')) {
      CloseAlert();
    }
    if ($(target).parents().hasClass('buy-all-func') || $(target).hasClass('buy-all-func')) {
      let wishListId = $(target).closest('.buy-all-func').attr('data-wishlistid');
      BuyAll(wishListId);
    }
  });
});

function BuyAll(wishListId) {
  var products = [];
  $("#tab3 .profile-product-group[data-wl-id='" + wishListId + "'] .product-list-container .product_item").each(function () {
    var isChecked = $(".btn-watchlist", $(this)).length == 0 && $(".check-product", $(this)).is(":checked") && !$(".check-product", $(this)).hasClass("product-disabled");
    if (isChecked) {
      var id = $(".check-product", $(this)).data('productidentifier');
      products.push(id);
    }
    $(".check-product", $(this)).prop('checked', false);
  });
  if (products.length > 0) {

    var successHandler = function (data) {
      if (!data) {
        alert("Det gick inte att lägga till din vara till kundkorgen.");
        isAddingToCart = false;
        return;
      }

      GetCartInfo(GetCart(true));
    };

    AddProducts(products, successHandler);
  }
}

function GetCart(isGetAndra, callback) {
  var count = 0;
  var basketHeight = $(".basket-table").height();

  var isCheckout = $("html.checkout-page, html.order-from-catalog-page").length > 0 || $("html.cart-page").length > 0 || $("html.shipping-page").length > 0;

  if (isCheckout) {
    $(".checkout-container-empty").hide();
  }

  $.ajax({
    url: "/api/cart/GetProducts",
    cache: false,
    dataType: "json",
    success: function (data) {

      if (data.length) {
        var templateId = "#cartProductsTemplate";
        var scrollTop = $(".basket-table-wrapper").scrollTop();
        var template = $.templates(templateId);
        var outerHtml = template.render({ CartProducts: data });
        $(".basket-table").height(basketHeight);
        if (outerHtml.length > 0) {
          if (isCheckout) {
            $(".basket-table-wrapper").children().not(".text-holder, .basket-top-panel, .payment-holder").remove();
            $(".inner-basket .delivery-info").before(outerHtml);
          }
          else {
            $(".basket-wrapper").children().not(".text-holder, .basket-top-panel, .payment-holder").remove();
            $(".basket-wrapper .text-holder").before(outerHtml);
          }

          $(".basket-table-wrapper").scrollTop(scrollTop);

          if (isGetAndra) {
            GetAndraForCart();
          }

          if (data.length > 0) {
            $(".basket-table-wrapper .emptyCartMessage").hide();
          }

          if (callback) {
            callback();
          }

        }
      }
      $(".basket-table").height("auto");
    }
  });

  return count;
}

function GetCartInfoFromCookie() {
  var cookieValue = $.cookie('GinzaCart');
  var count = 0;
  var price = "0:-";
  if (cookieValue && cookieValue.indexOf(";") > -1) {
    var splittedValues = cookieValue.split(';');
    if (splittedValues.length > 0) {
      count = splittedValues[1];
    }
    if (splittedValues.length > 1) {
      price = splittedValues[2];
    }

    if (splittedValues.length > 2) {
      var products = splittedValues[3];
      if (products && products.length > 0)
        window.cartProducts = products.split(',');
      CartProductsActivation();
    }
  }

  $(".summary.totalPriceValue").html(price);
  $('.amountProducts').text(count);
  $('#basketTitle').text(count === 0 ? 'Kundkorgen är tom' : 'Kundkorgen');
}

function GetCartInfo(callback) {

  $.ajax({
    url: "/api/cart/GetInfo",
    cache: false,
    dataType: "json",
    /**
     *
     * @param data
     */
    success: function (data) {
      
      if (data) {
        if ($("html.checkout-page").length > 0 && data.RedirectUrl && data.RedirectUrl.toLowerCase() != window.location.pathname.toLowerCase()) {
          window.location.href = data.RedirectUrl;
          return;
        }

        var isCheckout = $("html.checkout-page, html.order-from-catalog-page, html.cart-page, html.shipping-page, html.payment-page").length > 0;
        $(".cartSummary").show();
        $(".trFee").remove();

        if (data.Fees) {
          var template = $.templates('#cartFeesTemplate');
          var outerHtml = template.render(data);
          if (isCheckout) {
            $(".trDiscount").before(outerHtml);
          }
          else {
            $(".payment-table tr:first").after(outerHtml);
          }
          $(".trFee").show();
        }
        else {
          $(".trFee").hide();
        }

        if (data.ProductIdentifiers) {
          window.cartProducts = data.ProductIdentifiers.split(',');
          CartProductsActivation();
        }

        if (data.ProductCount > 0) {
          $(".item-count").html((data.ProductCount > 1) ? (data.ProductCount + " varor") : data.ProductCount + " vara");
          $(".basket-line.confirm-tooltip_holder").show();
        }
        else {
          $(".item-count").html(null);
          $(".recommendations-block").hide();
          $(".basket-line.confirm-tooltip_holder").hide();
        }

        if (data.IsDiscount) {
          $(".trDiscount").show();
          $(".trDiscount td:last-child").html(data.CartDiscount);
        }
        else {
          $(".trDiscount").hide();
        }

        $(".tdSumma").html(data.CartSum);
        $(".totalPrice").html(data.CartTotal);

        if (!data.IsFreeshipLi) {
          $(".liFreeShipping").hide();
        }
        else {
          $(".liFreeShipping").show();
          $(".liFreeShipping").html(data.FreeshipMessage);
        }
        $(".ltrPeriodicCost").html(data.PeriodicCost);
        if (data.EmptyMessage) {
          $(".emptyCartMessage").show();
          $(".emptyCartMessage").html(data.EmptyMessage);
          $("table.basket-table ").remove();
          $(".checkout-holder").hide();
        }
        else {
          $(".emptyCartMessage").hide();
          $(".checkout-holder").show();
        }

        if (isCheckout) {
          if (data.ProductCount > 0) {
            $(".delivery-info").show();
            ShowDeliveryDetailsInfo(data);
            $(".delivery-info .sending-status").text(data.DeliveryStatusOrder);

            $(".checkout-total-info .checkout-price strong").html(data.CartTotal);
          }
          else {
            $(".checkout-container-empty").show();
            $(".payment-method-holder").remove();
            $(".inner-basket").children().not(".cart-info, .delivery-info, .basket_user-choice-hodler").remove();
            $(".inner-basket").children(".cart-info, .delivery-info, .basket_user-choice-hodler").hide();
            $(".recommendations-block-checkout").remove();
          }
        }

        $(".summary.totalPriceValue").html(data.CartTotal);
        CalculateAmount(data.TotalProductCount);

        if (data.AreOnlyGiftVouchers) {
          $("#divCart #divShipping").hide()
        } else {
          $("#divCart #divShipping").show()
        }
        
        let shippingPageToPaymentBtn = $("#ShippingPageToPaymentBtn");
        
        if (data.ShippingIdentifier) {
          $('.presentkord-drop .submit-voucher').prop('disabled', false);
          
          if (data.ShippingProviderDto != null && data.ShippingProviderDto.SelectedShippingServicePointModel == null) {
            if (data.ShippingProviderDto.ShippingProviderIsMandatory) {
              shippingPageToPaymentBtn.addClass("btn-disabled")
            } else {
              shippingPageToPaymentBtn.removeClass("btn-disabled")
            }
          } else {
            shippingPageToPaymentBtn.removeClass("btn-disabled")
          }
        } else {
          shippingPageToPaymentBtn.addClass("btn-disabled")
        }
        
        let cartPageToShippingBtn = $("#CartPageToShippingBtn");
        cartPageToShippingBtn.removeClass("show-loader");        
        if (data.ProductCount === 0) {
          cartPageToShippingBtn.addClass("btn-disabled")
        }
        
        shippingPageToPaymentBtn.removeClass("show-loader");
        $('.func-cart-shipping-selector').prop('disabled', false);
        $('.country_select').prop('disabled', false);
        $('input[id^="additional-service-"]').prop('disabled', false);
        $('#ShippingPageReturnToCartBtn').removeClass("btn-disabled");
        $('#CartContinueShipping').removeClass("btn-disabled");        
        $(".basket-table-wrapper .basket-table .productItem").removeClass("disabled");
      }

      let shippingInputRadios = $(".delivery-table input");
      for (let i = 0; i < shippingInputRadios.length; i++) {
        shippingInputRadios[i].checked = shippingInputRadios[i].id === data.ShippingIdentifier;
      }
      
      if (callback) {
        callback();
      }
    }
  });
}

const DeliveryWaitingCategoryEnum = {
  Normal: 0,
  Uncertain: 1
}

function ShowDeliveryDetailsInfo(data) {
  let deliveryInfoSpanHTMLElement = $("#cart-delivery-details-info");

  deliveryInfoSpanHTMLElement.text(data.DeliveryStatusLongestProduct.Message);

  if (data.DeliveryStatusLongestProduct.WaitingCategory === DeliveryWaitingCategoryEnum.Uncertain) {
    deliveryInfoSpanHTMLElement.removeClass("black")
    deliveryInfoSpanHTMLElement.addClass("red")
    return;
  }

  deliveryInfoSpanHTMLElement.removeClass("red")
  deliveryInfoSpanHTMLElement.addClass("black")
}

function ChangeQuantityForProduct(element) {
  var parent = element.parents('.productItem');

  var productId = parent.data('id');
  var isTextbox = element.is("input");
  var newQuantity = 0;
  var quantityTextBox;
  if (isTextbox) {
    var val = element.val();
    var originalQuantity = element.data("originalvalue");
    if (isNaN(val) || val == originalQuantity) {
      return;
    }
    newQuantity = parseInt(Math.abs(val));
  }
  else {
    var isIncrease = element.hasClass("incr");
    quantityTextBox = element.parent().find("input");
    var currentQuantity = quantityTextBox.val();
    if (isNaN(currentQuantity)) {
      return;
    }
    currentQuantity = parseInt(currentQuantity);
    newQuantity = isIncrease ? currentQuantity + 1 : currentQuantity - 1;
  }

  if (newQuantity == 0) {
    parent.find('.confirm-tooltip').addClass("active");

    return false;
  }

  var isQliroLoaded = $(".QliroCheckout").length > 0;
  if (isQliroLoaded && typeof window.q1 === "object") {
    window.q1.lock();
  }
  
  DisableControls();

  var quantityObj = {};
  quantityObj.Quantity = newQuantity;
  quantityObj.ProductIdentifier = productId.toString();
  
  $.ajax({
    type: "POST",
    url: "/api/Cart/ChangeQuantity",
    data: JSON.stringify(quantityObj),
    contentType: "application/json",
    success: function (data) {

      function EnableButton() {
        if (newQuantity == 0) {
          ChangeButtonBack(productId);
          var itemToRemove = $("#cart-display .inner .content tr[data-id='" + productId + "']");
          if (itemToRemove) {
            itemToRemove.remove();
          }
        }
        else {
          ChangeButton(productId, newQuantity);
          if (!isTextbox) {
            quantityTextBox.val(newQuantity);
            quantityTextBox.removeProp("disabled");
          }
          else {
            element.val(newQuantity);
          }
          parent.find("td.price").html(newQuantity);
        }
      }

      if (data) {
        if ($("html.checkout-page").length > 0 && ((data.RedirectUrl && data.RedirectUrl.toLowerCase() != window.location.pathname.toLowerCase()) || data.ForceRedirect)) {
          window.location.href = data.RedirectUrl;
          return;
        }
        
        GetCart();
        GetCartInfo();
      }
    }
  });
}

function ChangeButton(productId, productCount) {
  var buttons = $('.prod_' + productId + ",#" + productId + ",#c_" + productId);

  var l = buttons.length;
  for (var i = 0; i < l; i++) {
    if ($(buttons[i]).hasClass('added') && !productCount) {
      return false;
    }

    $(buttons[i]).fadeOut('fast', function () {
      $(this).text(productCount + " st i kundkorg");
      $(this).addClass('added');
      $(this).fadeIn('fast');
    });
  }

  return true;
}

function ChangeButtonBack(productId) {

  var buttons = $('.prod_' + productId + ",#" + productId + ",#c_" + productId);

  var l = buttons.length;
  for (var i = 0; i < l; i++) {
    $(buttons[i]).fadeOut('fast', function () {
      $(this).text('Lägg i kundkorg');
      $(this).removeClass('added');
      $(this).fadeIn('fast');
    });

  }

  if ($(".competition-product .comp-product").length > 0 && $(".competition-product .comp-product").hasClass("prod_" + productId) && $(".competition-product p.added").length == 0) {
    $('.chk-already-bought input').prop('checked', false).prop('disabled', false);
    $('.chk-already-bought').prop('disabled', false);
    $(".btn-tavliga").prop("disabled", true);
  }

  return true;
}


function DeleteCartProduct(productIdentifier, element) {
  var isQliroLoaded = $(".QliroCheckout").length > 0;
  if (isQliroLoaded && typeof window.q1 === "object") {
    window.q1.lock();
  }
  
  DisableControls();
  
  $.ajax({
    type: "POST",
    url: "/api/cart/DeleteProduct",
    data: JSON.stringify(productIdentifier),
    contentType: "application/json",
    success: function (data) {
      if (data != null) {

        if ($("html.checkout-page").length > 0 && ((data.RedirectUrl && data.RedirectUrl.toLowerCase() != window.location.pathname.toLowerCase()) || data.ForceRedirect)) {
          window.location.href = data.RedirectUrl;
          return;
        }
        if (productIdentifier) {
          ChangeButtonBack(productIdentifier);
        }
        if (element) {
          var itemToRemove = element.parents("tr.productItem");
          if (itemToRemove) {
            itemToRemove.remove();
          }
        }
        
        GetCartInfo(GetCart(true));

      }
    }
  });
}

function DeleteDiscountProduct(promoId) {
  if (promoId == 0)
    return;

  var isQliroLoaded = $(".QliroCheckout").length > 0;
  if (isQliroLoaded && typeof window.q1 === "object") {
    window.q1.lock();
  }
  $.ajax({
    type: "POST",
    url: "/api/checkout/DeleteDiscountProduct",
    data: JSON.stringify(promoId),
    contentType: "application/json",
    success: function (data) {

      if (location.pathname.startsWith('/checkout/payment')) {
        window.location.reload();
      }
      else {
        GetCartInfo();
      }
    }
  });
}


function ClearCart() {
  $.ajax({
    type: "POST",
    url: "/api/cart/ClearCart",
    contentType: "application/json",
    success: function (data) {
      if (data) {
        window.deletedCartProducts = data;
        ClearCartChangeButtons();

        GetCartInfo(GetCart(true));
        $(".confirm-tooltip").removeClass("active");
      }
    }
  });
}
function ClearCartChangeButtons() {
  if (typeof (window.deletedCartProducts) != 'undefined') {
    if (typeof (window.cartProducts) != 'undefined') {
      window.cartProducts = [];
    }
    var arrLength = window.deletedCartProducts.length;
    for (var t = 0; t < arrLength; t++) {
      var buttons = $("#" + window.deletedCartProducts[t] + ",.prod_" + window.deletedCartProducts[t]);

      var l = buttons.length;

      for (var i = 0; i < l; i++) {
        var button = $(buttons[i]);
        button.fadeOut('fast');
        button.text('Lägg i kundkorg');
        button.removeClass('added');
        button.fadeIn('fast');
      }
    }
  }
}
function CalculateAmount(totalAmount) {
  $('.amountProducts').text(totalAmount);
  $('#basketTitle').text(totalAmount === 0 ? 'Kundkorgen är tom' : 'Kundkorgen');
  totalAmount > 1 ? $('#clearAll').show() : $('#clearAll').hide();
}

var isAddingToCart = false;

function AddToCartProduct(button, id, price, ticket, gaEvent) {
  if (button.filter(':animated').length > 0 || button.parents(".submit").hasClass('added')) {
    return false;
  }

  if (isAddingToCart)
    return false;

  isAddingToCart = true;

  var isQliroLoaded = $(".QliroCheckout").length > 0;
  if (isQliroLoaded && typeof window.q1 === "object") {
    window.q1.lock();
  }

  var errorHandler = function (jqXHR, exception) {
    LogError(jqXHR, exception);

    if (confirm('Det gick inte att lägga till din vara till kundkorgen. Vill du försöka igen?')) {
      AddToCartProduct(id);
    } else {
      $(".fakeItem").remove();
    }

    isAddingToCart = false;
  };

  var successHandler = function (data) {
    if (!data) {
      alert("Det gick inte att lägga till din vara till kundkorgen.");
      isAddingToCart = false;
      return;
    }
    if ($("html.checkout-page").length > 0 && ((data.RedirectUrl && data.RedirectUrl.toLowerCase() != window.location.pathname.toLowerCase()) || data.ForceRedirect)) {
      window.location.href = data.RedirectUrl;
      return;
    }



    if ($(".basket-drop").css('visibility') != "hidden") {

      GetCartInfo(GetCart(true, function () {
        if (isQliroLoaded) {
          QliroUpdate();
        }
      }));
    }
    else {
      $(".summary.totalPriceValue").html(data.TotalSum);
      CalculateAmount(data.ProductCount);
    }
    ChangeButton(id, data.CurrentProductCount);

    var pageName = '';
    if ($('html').data('page-name')) {
      pageName = $('html').data('page-name');
    }
    if (pageName.length < 1) {
      pageName = 'Main'
    }
    var productParentLittle = button.parents("div[id$='divLittleAndra']");
    var productParentMerAv = button.parents("div[id$='divMerAv']");
    var productParent = button.parents("li.productItem").prevAll("li.liSubPanelHead");
    var productApptusRecommendationsParent = button.parents(".holder");
    var productGinzaRecommendationsParent = button.parents(".ginza-recommendations");
    var apptusProductDivParent = button.parents("#ApptusProductDiv");
    if (productParentLittle.length > 0) {
      pageName += "-" + productParentLittle.data("gapagename");
    }
    if (productParentMerAv.length > 0) {
      pageName += "-" + productParentMerAv.data("gapagename");
    }
    if (productParent.length > 0) {
      pageName += "-" + productParent.data("gapagename");
    }
    if (productApptusRecommendationsParent.length > 0) {
      var text = productApptusRecommendationsParent.data("gapagename");
      if (text != null)
        pageName += "-" + text;
    }
    if (productGinzaRecommendationsParent.length > 0) {
      pageName += "-" + productGinzaRecommendationsParent.data("gapagename");
    }
    if (apptusProductDivParent.length > 0)
      pageName += "-apptusProduct"

    var sidebarParent = button.parents("aside[id$='sidebar']");
    if (sidebarParent.length > 0) {
      pageName += "-sidebar";
    }

    var ulParentClass = button.parents("#category-tabs").find("ul.tabs-nav li.apptus-tab.active").prop("id");
    if (ulParentClass && ulParentClass.length > 0) {
      if (ulParentClass.indexOf("SO_ALL") > -1) {
        pageName += '-basta-traff';
      }
      if (ulParentClass.indexOf("SO_BOOKED") > -1) {
        pageName += '-mest-bokade';
      }
      if (ulParentClass.indexOf("SO_PLO2") > -1) {
        pageName += '-mest-prissankta';
      }
      if (ulParentClass.indexOf("SO_UNTILTODAY") > -1) {
        pageName += '-senast-slappta';
      }
      if (ulParentClass.indexOf("SO_AFTERTODAY") > -1) {
        pageName += '-kommande-releaser';
      }
      if (ulParentClass.indexOf("SO_ARTA") > -1) {
        pageName += '-alpha';
      }
      if (ulParentClass.indexOf("SO_PRICE") > -1) {
        pageName += '-price';
      }
      if (ulParentClass.indexOf("SO_SOLD") > -1) {
        pageName += '-mest-salda';
      }
      pageName += '-tab';
    }

    var ulTopParentClass = $("#toplist");
    if (ulTopParentClass && ulTopParentClass.length > 0) {
      if (ulTopParentClass.find("ul.tabs-nav li.active a").length > 0) {
        pageName += "-" + ulTopParentClass.find("ul.tabs-nav li.active a").text();
      }
      else if (ulTopParentClass.find("select.active").length > 0) {
        pageName += "-" + ulTopParentClass.find("select.active option:selected").text();
      }
    }
    var ulGalleryParentClass = button.parents(".product-gallery-holder");
    if (ulGalleryParentClass && ulGalleryParentClass.length > 0) {
      if (ulGalleryParentClass.find(".section-subheading h2").length > 0) {
        pageName += "-" + ulGalleryParentClass.find(".section-subheading h2").text();
      }
      else {
        ulGalleryParentClass = button.parents(".info-section");
        if (ulGalleryParentClass && ulGalleryParentClass.length > 0 && ulGalleryParentClass.children("h1").first().length > 0) {
          pageName += "-" + ulGalleryParentClass.children("h1").first().text();
        }
      }
    }
    var priceInt = parseInt(price.replace(':-', '').replace('€', ''));
    const eventDataLayerValue = new GoogleUaEvent("CustomerActionEvent"); 
    
    if (gaEvent && !isNaN(priceInt)) {
      eventDataLayerValue.setPayload('kopknapp', 'Lagg i kundkorgen', gaEvent, priceInt)
    }
    else if (!isNaN(priceInt)) {
      eventDataLayerValue.setPayload('kopknapp', 'Lagg i kundkorgen', pageName, priceInt)
    }
    const dataLayerService = new DataLayerService();
    dataLayerService.triggerUaEvent(eventDataLayerValue)

    if (typeof (fbq) != 'undefined') {
      fbq('track', 'AddToCart');
    }

    isAddingToCart = false;
  };

  AddProduct(id, price, successHandler, errorHandler, ticket);


  return false;
}

function AddProduct(id, price, successFunction, errorFunction, ticket) {
  var data = { ProductIdentifier: id };
  if (typeof (ticket) != "undefined") {
    data.Ticket = ticket;
  }

  var promise = $.ajax({
    method: "POST",
    data: JSON.stringify(data),
    contentType: "application/json",
    url: "/api/cart/AddProductToCart",
  });

  if (typeof (successFunction) != "undefined") {
    promise.done(successFunction);
  }
  if (typeof (errorFunction) != "undefined") {
    promise.fail(errorFunction);
  }
}

function AddProducts(ids, successFunction, errorFunction) {
  var l = ids.length;

  for (var i = 0; i < l; i++) {
    ChangeButton(ids[i]);
  }

  var promise = $.ajax({
    method: "POST",
    data: JSON.stringify(ids),
    contentType: "application/json",
    url: "/api/cart/AddProductsToCart",

  });

  if (typeof (successFunction) != "undefined") {
    promise.done(successFunction);
  }
  if (typeof (errorFunction) != "undefined") {
    promise.fail(errorFunction);
  }
}
function ConfirmDeleting(sender) {

  if (sender.parent().children().length > 1) {
    $('.confirm-tooltip').not(sender.parent().find('.confirm-tooltip')).removeClass("active");
    sender.parent().find('.confirm-tooltip').addClass("active");
  }
}
function CloseAlert() {
  $('div.confirm-tooltip').removeClass("active");
  return false;
}
function ShowClearAllAlert() {
  $('#clearAll').siblings('div.confirm-tooltip').addClass("active");
  return false;
}

function CartProductsActivation() {
  if (typeof (window.cartProducts) != 'undefined') {
    var productsLength = window.cartProducts.length;
    var productIds = window.cartProducts;
    var amounts = []
    $.ajax({
      url: "/api/cart/GetProductsCountInCart?productIds = " + productIds,
      type: "GET",
      success: function (data) {
        amounts = data;
        for (var t = 0; t < productsLength; t++) {
          var products = $("#" + window.cartProducts[t] + ",.prod_" + window.cartProducts[t]);

          for (var t = 0; t < productsLength; t++) {
            if (!isNaN(window.cartProducts[t])) {
              var products = $("#" + window.cartProducts[t] + ",.prod_" + window.cartProducts[t]);

              if ($(".top-products-section").length > 0) {
                $(".top-products-section .top-product__item .top-product__img-holder img").each(function () {
                  if ($(this).prop("src").indexOf(window.cartProducts[t]) > 0) {
                    var btn = $(this).parent().next(".product_details-datetype-holder").find("a.btn");
                    if (btn) {
                      products.push(btn);
                    }
                  }
                });
              }

              if (products) {
                var l = products.length;

                for (var i = 0; i < l; i++) {
                  var amount = 1;
                  if (amounts[t] == undefined) {
                    $(products[i]).text(amount + ' st i kundkorg').addClass('added');
                  }
                  else {
                    $(products[i]).text(amounts[t] + ' st i kundkorg').addClass('added');
                  }
                }
              }
            }
          }
        }
      }
    })


  }
}


function GetAndraForCart() {
  var isCheckout = ($('.cart-page').length > 0 || $('.checkout-page').length > 0);

  $.ajax({
    url: "/api/cart/GetAndra",
    type: "GET",
    data: {
      isCheckout: isCheckout
    },
    success: function (data) {
      var offers = $(".recommendations-block");
      if (isCheckout) {
        offers = $("#recommendations-block-checkout");
      }
      offers.empty();
      if (data != null && typeof (data) != 'undefined' && data.length > 0) {

        var template = $.templates('#recommendationsInBasketTemplate');
        if (isCheckout) {
          template = $.templates('#recommendationsInCheckoutTemplate');
        }
        var outerHtml = template.render({ Products: data });

        offers.append($(outerHtml));
        offers.show();

        CartProductsActivation();
      }
      else {
        offers.addClass('display-none');
        offers.hide();
      }

    }
  });
  if (isCheckout) {
    $.ajax({
      url: "/api/cart/GetCustomAndra",
      type: "GET",
      success: function (data) {
        var offers = $("#customRecommendations-block-checkout");

        offers.empty();
        if (data && data.Products.length > 0) {

          var template = $.templates('#customRecommendationsInCheckoutTemplate');

          var outerHtml = template.render({ Header: data.Header, Products: data.Products });

          offers.append($(outerHtml));
          offers.show();

          CartProductsActivation();
        }
        else {
          offers.addClass('display-none');
          offers.hide();
        }

      }
    })
  }
}

var initCatalog = function () {
  var $orderTable = $('.order-table');
  var $button = $orderTable.find('button[type="button"]');
  var $textbox = $orderTable.find('.inputTextBox');
  var $quantityTextbox = $orderTable.find('.quantity input[type="text"]');
  $(".basket_user-choice-hodler").hide();
  if ($button.length > 0) {
    if ($textbox.length > 0) {
      $textbox.on("keyup", function (e) {
        if (e.keyCode == 13) {
          $button.click();
        }
      });
    }
    if ($quantityTextbox.length > 0) {
      $quantityTextbox.off();
      $quantityTextbox.on("keyup", function (e) {
        if (e.keyCode == 13) {
          $button.click();
        }
      });
    }



    $button.off().on('click', function (e) {
      e.preventDefault();

      var productId = $orderTable.find('.inputTextBox').val().trim();
      $textbox.removeClass("error");
      if (productId == "" || isNaN(productId)) {
        $textbox.addClass("error");
        return;
      }

      isAddingToCart = true;


      var errorHandler = function (jqXHR, exception) {
        LogError(jqXHR, exception);

        if (confirm('Det gick inte att lägga till din vara till kundkorgen. Vill du försöka igen?')) {
          AddToCartProduct(productId);
        }

        isAddingToCart = false;
      };

      var successHandler = function (data) {
        if (!data) {
          alert("Det gick inte att lägga till din vara till kundkorgen.");
          isAddingToCart = false;
          return;
        }

        GetCartInfo(GetCart(false, function () {
          var price = $(".cartBackground .cartProductlist tr.productItem[data-id='" + productId + "'] td.price").html();
          if (!price || price.length == 0) {
            return;
          }
          var pageName = '';
          if ($('html').data('page-name')) {
            pageName = $('html').data('page-name');
          }
          var priceInt = parseInt(price.replace(':-', '').replace('€', ''));
          if (!isNaN(priceInt)) {
            let googleUaEvent = new GoogleUaEvent('CustomerActionEvent');
            googleUaEvent.setPayload('kopknapp', 'Lagg i varukorgen', pageName, priceInt)
            dataLayerService.triggerUaEvent(googleUaEvent);
          }
        }));

        ChangeButton(productId);

        $orderTable.find('.inputTextBox').val('');

        isAddingToCart = false;

      };

      var amount = parseInt($orderTable.find('.quantity input[type="text"]').val());

      if (isNaN(amount) || amount == 1) {
        AddProduct(productId, 0, successHandler, errorHandler);
      }
      else {
        var products = [];

        for (var i = 0; i < amount; i++) {
          products.push(productId);
        }

        AddProducts(products, successHandler, errorHandler);

      }

      $orderTable.find('.quantity input[type="text"]').val('1');
    });

    var $incr = $orderTable.find('.quantity span.incr');
    $incr.off().on('click', function (e) {

      var amount = parseInt($orderTable.find('.quantity input[type="text"]').val());

      if (isNaN(amount)) {
        amount = 1;
      }
      else {
        amount++;
      }

      $orderTable.find('.quantity input[type="text"]').val(amount);
    });

    var $decr = $orderTable.find('.quantity span.decr');
    $decr.off().on('click', function (e) {

      var amount = parseInt($orderTable.find('.quantity input[type="text"]').val());

      if (isNaN(amount) || amount < 2) {
        amount = 1;
      }
      else {
        amount--;
      }

      $orderTable.find('.quantity input[type="text"]').val(amount);
    });
  }
}

export { GetCartInfo, GetCart, ConfirmDeleting, AddToCartProduct, DeleteCartProduct, CloseAlert, ClearCart, CartProductsActivation, AddProducts };
